import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WeDermaLogo',
  props: {
  width: { default: 136 },
  height: { default: 24 }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})